var map = {
	"./de/video-btn.png": "yGsl",
	"./en/video-btn.png": "F4Pb",
	"./es/video-btn.png": "chxy",
	"./fr/video-btn.png": "+n7/",
	"./ja/video-btn.png": "13VU",
	"./ko/video-btn.png": "mOz8",
	"./pt/video-btn.png": "YNCf",
	"./ru/video-btn.png": "1Lxu",
	"./tc/video-btn.png": "l9Je",
	"./th/video-btn.png": "qlwv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m5bu";